export const INBOX_NOTIFICATIONS_CHANGED_EVENT = 'inbox-notifications-changed'

export function notifyInboxNotificationsChanged() {
  window.dispatchEvent(new CustomEvent(INBOX_NOTIFICATIONS_CHANGED_EVENT))
}
